import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./generalArchivistica.css";
import { Interes_item } from "../../json/generalArchivistica";

const GeneralArchivistica = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const linkStyle = {
    textDecoration: "none",
  };

  return (
    <div className="container archivistica-container">
      <div className="row">
        <div className="col_12">
          <div className="archivistica_title">
            <h1>General Archivística</h1>
          </div>
        </div>
      </div>
      <div className="row">
        {Interes_item.map((item, index) => (
          <div key={index} className="col-md-4 archivistica-card">
            <Link style={linkStyle} to={item.url}>
            <div className='archivistica_container'>
                    <h3>{ item.nombre }</h3>
                  </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GeneralArchivistica;